import { useContext, useEffect } from 'react';
import classNames from 'classnames';

import TickIcon from 'assets/icons/tick.svg';
import { CompareContext } from '@providers/CompareProvider';
import FormattedMessage from '@components/FormattedMessage';
import NoSSR from '@misc/NoSSR';
import useBoolean from 'hooks/useBoolean';

import classes from './AddToCompare.module.scss';
import messages from './AddToCompare.messages';

type Props = {
  id: number;
  productTypeId: number;
};

const AddToCompare = ({ id, productTypeId }: Props): JSX.Element => {
  const { isInCompare, isRefreshed, addToCompare, removeFromCompare } = useContext(CompareContext);
  const [currentState, { setValue: setCurrentState }] = useBoolean(false);

  const isAddedToCompare = isInCompare(id, productTypeId);

  useEffect(() => {
    if (isRefreshed) {
      setCurrentState(isAddedToCompare);
    }
  }, [isRefreshed, isAddedToCompare]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <NoSSR>
      <div
        className={classes.wrapper}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          if (currentState) {
            removeFromCompare(id, productTypeId);
          } else {
            addToCompare(id, productTypeId);
          }
        }}
      >
        {currentState ? (
          <>
            <TickIcon className={classes.icon} width={12} />
            <div className={classNames(classes.info, { [classes.active]: currentState })}>
              <FormattedMessage {...messages.addedToCompare} />
            </div>
          </>
        ) : (
          <div className={classNames(classes.info, { [classes.active]: currentState })}>
            <span className={classes.mobileCompare}>
              <FormattedMessage {...messages.toCompare} />
            </span>
            <span className={classes.desktopCompare}>
              <FormattedMessage {...messages.addToCompare} />
            </span>
          </div>
        )}
      </div>
    </NoSSR>
  );
};

export default AddToCompare;
